import { SET_CURRENTLY_DRAGGED_PROJECT_ID, SET_IS_DRAGGING } from "../../actions/setIsDragging";

const initialState = {
    isDragging: false,
    currentlyDraggedProjectId: null,
};

const isDraggingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_DRAGGING:
            return {
                ...state,
                isDragging: action.payload,
            };
        case SET_CURRENTLY_DRAGGED_PROJECT_ID:
            return {
                ...state,
                currentlyDraggedProjectId: action.payload,
            };
        default:
            return state;
    }
};

export default isDraggingReducer;
